import React, { useEffect } from 'react';
import Navigation from '../components/layout/nav';
import './home.css';
import detailicon1 from './../assets/eventicon01.svg'
import detailicon2 from './../assets/eventicon02.svg'
import detailicon3 from './../assets/eventicon03.svg'
import detailicon4 from './../assets/eventicon04.svg'
import CategoryCard2 from '../sections/category2';
import HeadingBlock from '../components/common/heading';
import Button from '../components/common/button';
import './../components/layout/footer.css'
import PopUp from '../components/layout/popup';
const Home = () => {
  useEffect(() => {
    const originalColor = window.getComputedStyle(document.body).backgroundColor;
    document.body.style.setProperty('background-color', '#FFF4E2', 'important');

    return () => {
      document.body.style.removeProperty('background-color');
      document.body.style.backgroundColor = originalColor;
    };
  }, []);

  return (
    <>
    <PopUp />
    <header className='fixedWidth'>
        <HeadingBlock label="Featured Event" heading="EgyCraft Fair 2026" style1="dark left decor"/>
        <div className="detailFlex">
            <div className="detailiconFlex ">
                <div className="color1">
                <img src={detailicon2} alt="Detail Icon 1" />
                </div>
                10am - 10pm
            </div>
            <div className="detailiconFlex ">
                <div className="color2">
                <img src={detailicon4} alt="Detail Icon 1" />
                </div>
                City Center Almaza
            </div>
            <div className="detailiconFlex ">
                <div className="color1">
                <img src={detailicon3} alt="Detail Icon 1" />

                </div>
                March 15-20
            </div>
            <div className="detailiconFlex ">
                <div className="color2">
                <img src={detailicon1} alt="Detail Icon 1" />
                </div>
                250EGP
            </div>
        </div>
        <div className="btnFlex">
          <a href="/exhibitiondetails">View Details</a>
         <Button cta="Book Now"
        link="/booking"
        style1="size1 blue"
        />
        </div>
        {/* <Button cta="View Details" link="/event" /> */}
    </header>
      <main>
        <CategoryCard2 />
      </main>
      <Navigation />
    </>
  );
};

export default Home;